// extracted by mini-css-extract-plugin
module.exports = {"tourMessage":"SendMessage_tourMessage__3VyIz","tourDuration":"SendMessage_tourDuration__34lzh","tourUrgent":"SendMessage_tourUrgent__nwV4X"};